import React from 'react'
import './style.css'
const Pointers = () => {
  return (
    <>
    <div className='signature Profile PointersMain PointersDiv' >
    <div className=' Pointers PointersMainLeft'>
    <div className="ProfileLink ">
     <div className="PointersInfo Info signature_info" style={{textDecoration:'none',textAlign:'center',marginTop:'-10px',textAlign:'center',color:'white'}}>
       <h3 style={{fontSize:'30px',fontWeight:'600'}}>1</h3>
       <p>YEAR EXPERIENCE</p>
     </div>
     
   </div>
    </div>
    <div className='Pointers '>
    <div className="ProfileLink ">
     <div className="PointersInfo Info signature_info" style={{textDecoration:'none',textAlign:'center',marginTop:'-10px',textAlign:'center',color:'white'}}>
       <h3 style={{fontSize:'30px',fontWeight:'600'}}>+1</h3>
       <p>CLIENT WORLDWIDE</p>
     </div>
     
   </div>
    </div>
    <div className='Pointers '>
    <div className="ProfileLink ">
     <div className="PointersInfo Info signature_info" style={{textDecoration:'none',textAlign:'center',marginTop:'-10px',textAlign:'center',color:'white'}}>
       <h3 style={{fontSize:'30px',fontWeight:'600'}}>+1</h3>
       <p>TOTAL PROJECTS</p>
     </div>
     
   </div>
    </div>
    
   </div>
    
    </>
  )
}

export default Pointers
